import { NotificacionesService } from './../../../../services/notificaciones.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication.service';
import { EventosService } from '../../../../services/eventos.service';
import { UserService } from '../../../../services/user.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';


@Component({
  selector: 'app-miseventos',
  templateUrl: './miseventos.component.html',
  styleUrls: ['./miseventos.component.css']
})
export class MiseventosComponent implements OnInit {
  userUid: any;
  userdata: any;
  eventos = [];
  orderbydate: boolean;
  orderbyname: boolean;




  constructor(private eventosService: EventosService,
              private userService: UserService,
              private NotificacionesService: NotificacionesService,
              private breadService: BreadcrumbService,
              private authenticationService: AuthenticationService) { }


  ngOnInit(): void {
    const Userdata: any = this.userService.getUserinfodata();
 
    if (Userdata === undefined) {
      this.getmainuserdata();
    } else {
      this.userUid = Userdata.payload.doc.data().uid;
      this.eventosService.getEventosByUseridOrdenado(this.userUid).subscribe(eventos => {
        this.eventos = this.sortEventsNewestFirst(eventos);
      });
    }
  }


  /* trae informacion principal del usuario logueado */
  getmainuserdata() {
    this.authenticationService.isAuth().subscribe(auth =>{
      if(auth) {
        this.userUid = auth.uid; /* id del usuario */

        this.eventosService.getEventosByUseridOrdenado(this.userUid).subscribe(eventos => {
          this.eventos = this.sortEventsNewestFirst(eventos);
        });

      };
    });
  }

  
  UpdateBreadcrumb(name, url) {
    this.breadService.addtobread(name, url);
  }

  ordenarPorFecha() {
    this.orderbydate=!this.orderbydate;

    if(this.orderbydate){
      this.eventos = this.sortEventsOldestFirst(this.eventos);
    }
    else{
      this.eventos = this.sortEventsNewestFirst(this.eventos);
    }
    
  }

  private sortEventsNewestFirst(eventos: any[]) {
    return (eventos || []).slice().sort((a, b) => this.getEventStartTime(b) - this.getEventStartTime(a));
  }

  private sortEventsOldestFirst(eventos: any[]) {
    return (eventos || []).slice().sort((a, b) => this.getEventStartTime(a) - this.getEventStartTime(b));
  }

  private getEventStartTime(evento: any): number {
    const data = evento?.payload?.doc?.data ? evento.payload.doc.data() : evento;
    const value = data?.start_date || data?.fecha_inicio || data?.fechainicio;

    if (!value) {
      return 0;
    }

    if (value instanceof Date) {
      return value.getTime();
    }

    if (typeof value.toDate === 'function') {
      return value.toDate().getTime();
    }

    if (typeof value === 'object') {
      const seconds = value.seconds || value._seconds;
      if (typeof seconds === 'number') {
        return seconds * 1000;
      }
    }

    const parsedDate = new Date(value);
    return isNaN(parsedDate.getTime()) ? 0 : parsedDate.getTime();
  }

  ordenarDes(item){
    this.eventos.sort(function (a, b) {
      if (a.payload.doc.data()[item] < b.payload.doc.data()[item]) {
        return -1;
      } else if (a.payload.doc.data()[item] > b.payload.doc.data()[item]) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  ordenarAsc(item){
    this.eventos.sort(function (a, b) {
      if (a.payload.doc.data()[item] > b.payload.doc.data()[item]) {
        return -1;
      } else if (a.payload.doc.data()[item] < b.payload.doc.data()[item]) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  
  ordenarPorNombre() {
    this.orderbyname=!this.orderbyname;
    if(this.orderbyname){
      this.ordenarDes('nombre')
    }
    else{
      this.ordenarAsc('nombre')
    }
    
  }




}
